import { form } from '../formState'
import { useTexts } from '../../hooks/useTexts'
import { useDateFormatOptions } from '../hooks/useDateFormatOptions'

export function DateFormat() {
  const texts = useTexts()
  const options = useDateFormatOptions()

  return (
    <form.RadioGroup
      label={texts.dateFormat}
      validateOn="change"
      options={options}
      name="dateFormat"
      testId="dateFormat"
    />
  )
}
